import React, { useEffect, useRef } from 'react';

const InteractivePlot = ({ plotData, riskDriver, targetVar, title, xLabel, yLabel }) => {
  const plotRef = useRef(null);
  
  useEffect(() => {
    if (!plotData || !plotRef.current) return;
    
    const loadPlotly = () => {
      const plotJson = typeof plotData === 'string' ? JSON.parse(plotData) : plotData;
      
      if (plotJson.data) {
        plotJson.data.forEach(trace => {
          if (trace.type === 'bar') {
            trace.orientation = 'v';
          }
        });
      }
      
      if (!plotJson.layout.xaxis) {
        plotJson.layout.xaxis = {};
      }
      plotJson.layout.xaxis.tickangle = 0;
      plotJson.layout.xaxis.type = 'category';
      
      // Apply custom titles if provided
      if (title) plotJson.layout.title = title;
      if (xLabel) plotJson.layout.xaxis.title = xLabel;
      if (yLabel) plotJson.layout.yaxis.title = yLabel;
      
      if (window.Plotly) {
        window.Plotly.newPlot(plotRef.current, plotJson.data, {
          ...plotJson.layout,
          autosize: true,
          height: 500,
          hovermode: 'x unified'
        }, {
          responsive: true,
          displayModeBar: true,
          modeBarButtonsToRemove: ['lasso2d', 'select2d'],
          toImageButtonOptions: {
            format: 'png',
            filename: `${riskDriver}_vs_${targetVar}`,
            height: 800,
            width: 1200,
            scale: 2
          }
        });
      } else {
        const script = document.createElement('script');
        script.src = 'https://cdn.plot.ly/plotly-2.27.0.min.js';
        script.onload = () => {
          window.Plotly.newPlot(plotRef.current, plotJson.data, {
            ...plotJson.layout,
            autosize: true,
            height: 500
          }, {
            responsive: true,
            displayModeBar: true
          });
        };
        document.head.appendChild(script);
      }
    };
    
    loadPlotly();
    
    return () => {
      if (plotRef.current && window.Plotly) {
        window.Plotly.purge(plotRef.current);
      }
    };
  }, [plotData, riskDriver, targetVar, title, xLabel, yLabel]);
  
  return (
    <div style={{ marginTop: '20px', marginBottom: '20px' }}>
      <div ref={plotRef} style={{ width: '100%', minHeight: '500px' }} />
      <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
        <button 
          onClick={() => window.open(`/static/mi_plot_${riskDriver}.html`, '_blank')}
          style={{
            padding: '8px 16px', background: '#3498db', color: 'white',
            border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px'
          }}
        >
          🔍 Open Fullscreen
        </button>
      </div>
    </div>
  );
};

export default InteractivePlot;